<template>
    <form-select
        v-bind="$props"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
        width="auto"
    >
        <option v-for="timezone in timezones" :key="timezone.value" :value="timezone.value">{{ timezone.name }}</option>
    </form-select>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Autofocus from '../mixins/Autofocus.vue';
    import FormControl from '../mixins/FormControl.vue';
    import TIMEZONES from '../utils/timezones';

    export default {
        name: 'TimezoneChooser',
        mixins: [Autofocus, FormControl],
        data() {
            return {
                regionCode: 'CAN'
            }
        },
        computed: {
            ...mapGetters({
                org: 'org/org'
            }),
            timezones() {
                return TIMEZONES[this.regionCode].map(tz => {
                    return {
                        value: tz.name,
                        name: `${tz.name.replace(/_/g, ' ')} (GMT${tz.offset})`
                    };
                });
            }
        },
        methods: {
            setRegion(regionCode) {
                this.regionCode = regionCode;
            },
        },
        created() {
            if (this.value) {
                // Set timezone list region by the current value
                for (let regionCode in TIMEZONES) {
                    if (TIMEZONES[regionCode].includes(this.value)) {
                        this.setRegion(regionCode);
                        break;
                    }
                }
            } else if (this.org.region_code) {
                // Set timezone list region from the org
                this.setRegion(this.org.region_code);
            }
        }
    }
</script>